import {
  IChatMessageResponsePayload,
  IChatUserMessageResponsePayload,
} from '@livelike/javascript';

export type IChatMessage = IChatMessageResponsePayload & {
  isDeleted?: boolean;
};

export type IChatUserMessage = IChatUserMessageResponsePayload & {
  isDeleted?: boolean;
};
